// src/pages/Unauthorized.tsx
const Unauthorized = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white">
      <h1 className="text-3xl font-bold text-red-600 mb-4">🚫 Unauthorized Access</h1>
      <p className="text-gray-600">Anda tidak memiliki akses ke halaman ini.</p>
    </div>
  );
};

export default Unauthorized;
